import moment from "moment";
import React, { Component } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Badge, Modal, ModalBody, ModalHeader } from "reactstrap";
import { accessTypesArray, deepCompare } from "../../../../helpers/Utils";
import Rating from "../../../../components/common/Rating";
const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}
const colors = {
  reAssignProvider: '#145388',
  reAssignWorker: '#145388',
  rescheduleDate: '#145388',
  newAppointment: '#3498db',
  rejectedAppointment: '#c43d4b',
  canceledAppointment: '#c43d4b',
  statusChanged: '#3e884f',
  ratedAppointment: '#b69329',
  superAdminComment: '#000',
  cancellationFeesApplied: '#c43d4b',
  orderPaid: '#3e884f',
  orderUnpaid: '#c43d4b',
  reassignStarted: '#e08a00',
  reassignOffered: '#e08a00',
  reassignReplacementCreated: '#3e884f',
  reassignExhausted: '#c43d4b',
  reassignFailed: '#c43d4b',
  reassignSuppressed: '#6c757d',
  reassignExtended: '#145388',
  reassignRetried: '#145388',
  quickWashRebroadcast: '#e08a00',
  lowRatingDetected: '#c43d4b',
  complaintStatusChanged: '#e08a00',
  complaintResolved: '#3e884f',
  compensationIssued: '#145388',
  apologySent: '#145388',
  recoveryMarkedPaid: '#3e884f',
  canceledOrderChargeConfirmed: '#e08a00',
  priceRepaired: '#145388',
  priceRepairNeedsReview: '#c43d4b'
}
const aed = (v) => `AED ${Number(v || 0).toFixed(2)}`
const COMPLAINT_LABELS = { pending: 'Pending', inProgress: 'In Progress', open: 'Open', resolved: 'Resolved' }
const RESOLUTION_LABELS = { compensated: 'compensated (wallet)', voucher: 'voucher issued', explained: 'explained / apologised', providerWarned: 'provider warned', noAction: 'no action needed', other: 'other' }
// One log entry → human-readable message. Shared by the Logs modal and the inline list.
export function generateLogMessage(log, selectedBooking) {
    let msg = ''
    let createdBy = `${log?.createdByName || ''} ${capitalize(log.createdBy)}`
    switch (log.title) {
      case 'newAppointment':
        msg = createdBy + (accessTypesArray.includes(log.createdBy) ? ' created' : ' booked ') + ' appointment'
        break;
      case 'statusChanged':
        if (accessTypesArray.includes(log.createdBy) && log.createdBy !== 'Provider') {
          msg = createdBy + ' changed status from ' + log.oldsStatus + ' to ' + (log.status === 'new' ? 'pending' : log.status)

        } else {
          log.oldsStatus === 'pending' || log.oldsStatus === 'new' ?
            msg = createdBy + ' accepted appointment'
            : log.oldsStatus === 'accepted' ?
              msg = createdBy + ' arrived to customer'
              : msg = createdBy + ' completed appointment'

        }

        break;

      case 'ratedAppointment':
        msg = (
          <div>
            {createdBy + ' rated ' + log.service + ' with ' + log.score + ' stars'}<br />
            {'Feedback: ' + (log.comment || 'No Comment')}
            {selectedBooking?.score ? <div>Average Rate: {selectedBooking?.score}</div> : ''}
            {selectedBooking?.serviceRate ? <div className="d-flex align-items-center">Service Rate: <Rating total={5} rating={selectedBooking?.serviceRate} style={{ margin: '4px 8px' }} /></div> : ''}
            {selectedBooking?.workerRate ? <div className="d-flex align-items-center">Worker Rate: <Rating total={5} rating={selectedBooking?.workerRate} style={{ margin: '4px 8px' }} /></div> : ''}
            {selectedBooking?.arrivalTimingRate ? <div className="d-flex align-items-center">Arrival Timing Rate: <Rating total={5} rating={selectedBooking?.arrivalTimingRate} style={{ margin: '4px 8px' }} /></div> : ''}
          </div>
        );
        break;
      case 'rejectedAppointment':
        msg = <div>{createdBy + ' rejected appointment'}<br />
          {'Reason: ' + (selectedBooking?.cancelReason || 'No Comment')}</div>
        break;
      case 'canceledAppointment':
        msg = <div>{createdBy + ' canceled appointment'}<br />
          {'Reason: ' + (selectedBooking?.cancelReason || 'No Comment')}</div>
        break;
      case 'reAssignProvider':
        msg = createdBy + ' reassigned service provider from ' + log.oldProviderName + ' to ' + log.provider_name
        break;
      case 'reAssignWorker':
        msg = createdBy + ' reassigned worker from ' + log.oldWasherName + ' to ' + log.washer_name
        break;
      case 'rescheduleDate':
        msg = createdBy + ' recheduled appointment from ' + moment(log.oldBookingDate).format("DD/MM/YYYY hh:mm A") + ' to ' + moment(log.bookingDate).format("DD/MM/YYYY hh:mm A")
        break;
      case 'superAdminComment':
        msg = <div>{createdBy + ' left comment'}<br />
          {'Comment: ' + (log.comment || 'No Comment')}</div>
        break;
      case 'cancellationFeesApplied':
        msg = createdBy + ' applied cancellation fees for this order'
        break;
      case 'orderPaid':
        msg = createdBy + ' marked order as paid'
        break;
      case 'orderUnpaid':
        msg = createdBy + ' marked order as unpaid'
        break;
      case 'vehicleModified':
        let addedVehicles = deepCompare(log.oldVehicle, log.newVehicle).filter(r => r.origin === 'newVehicle').length
        let removedVehicle = deepCompare(log.oldVehicle, log.newVehicle).filter(r => r.origin === 'oldVehicle').length
        msg = <div>{createdBy + (addedVehicles ? ` added ${addedVehicles} vehicles` : '') + (removedVehicle ? ` ${addedVehicles ? 'and' : ''} removed ${removedVehicle} vehicles` : '')}<br />
          <div className="mt-2">
            {deepCompare(log.oldVehicle, log.newVehicle)?.map(c => {
              return (
                <p className="d-sm-inline-block mb-1 mr-1" key={c.vehicleId}>
                  <Badge
                    className="mb-1"
                    color={c.origin === 'newVehicle' ? 'primary' : 'danger'}
                    pill>
                    {c?.car_model + " " + c?.modelNumber?.model}
                  </Badge>
                </p>
              )
            })}
          </div>
        </div>
        break
      case 'reassignStarted':
        // rejectedBy is the provider name (string) in the intercept log
        msg = <div>{`Order recovery started: ${(typeof log.rejectedBy === 'string' ? log.rejectedBy : log.rejectedBy?.sp_name) || 'the provider'} ${log.kind === 'canceled' ? 'cancelled' : 'rejected'} the order`}
          {log.attempt > 1 ? ` (attempt ${log.attempt})` : ''}{log.reason ? ` — “${log.reason}”` : ''}<br />
          {'Searching for a replacement provider…'}</div>
        break;
      case 'reassignOffered':
        msg = <div>{`Order recovery: ${log.candidateCount ?? (Array.isArray(log.candidates) ? log.candidates.length : 0)} candidate(s) found`}
          {Array.isArray(log.candidates) && log.candidates.length ? <><br />{log.candidates.join(' · ')}</> : null}</div>
        break;
      case 'reassignReplacementCreated':
        msg = <div>{`Order recovery: replacement created with ${log.sp_name || 'a new provider'}${log.washer_name ? ' / ' + log.washer_name : ''}`}
          {log.by ? ` (picked by ${String(log.by).replace(/^admin:/, '')})` : ''}<br />
          {log.moneyBranch ? `Money: ${log.moneyBranch}` : ''}
          {log.refundToWallet > 0 ? `, ${aed(log.refundToWallet)} credited to wallet` : ''}
          {log.waived > 0 ? `, ${aed(log.waived)} absorbed by Chill` : ''}
          {log.replacementId ? <><br />{`Replacement booking: ${log.replacementId}`}</> : null}</div>
        break;
      case 'reassignExhausted':
        msg = `Order recovery ended: no replacement found (${log.reason || 'no candidates'}). Standard cancellation applied.`
        break;
      case 'reassignFailed':
        msg = `Order recovery: search failed${log.error ? ' — ' + log.error : ''}`
        break;
      case 'reassignSuppressed':
        msg = <div>{createdBy + ' suppressed order recovery'}<br />{'Reason: ' + (log.reason || '—')}</div>
        break;
      case 'reassignExtended':
        msg = createdBy + ` extended the customer window by ${log.minutes || 5} minutes`
        break;
      case 'reassignRetried':
        msg = createdBy + ' re-ran the replacement search'
        break;
      case 'quickWashRebroadcast':
        msg = <div>{`Quick wash: request widened to ${log.addedProviders || 0} more provider(s) / ${log.addedWorkers || 0} worker(s) before auto-cancel`}
          {Array.isArray(log.added) && log.added.length ? <><br />{log.added.join(', ')}</> : null}</div>
        break;
      case 'lowRatingDetected':
        msg = <div>{`Low rating ${log.score} / 5 flagged for support (threshold ≤ ${log.threshold})`}{log.backfilled ? ' — backfilled' : ''}</div>
        break;
      case 'complaintStatusChanged':
        msg = <div>{createdBy + ` moved the complaint from ${COMPLAINT_LABELS[log.oldStatus] || log.oldStatus || '—'} to ${COMPLAINT_LABELS[log.status] || log.status}`}
          {log.assigneeName ? ` (assignee: ${log.assigneeName})` : ''}
          {log.note ? <><br />{'Note: ' + log.note}</> : null}</div>
        break;
      case 'complaintResolved':
        msg = <div>{createdBy + ' resolved the complaint'}{log.resolutionType ? ` — ${RESOLUTION_LABELS[log.resolutionType] || log.resolutionType}` : ''}
          {log.resolutionNote ? <><br />{'Note: ' + log.resolutionNote}</> : null}</div>
        break;
      case 'apologySent':
        msg = <div>{"Apology push sent to the customer (case moved to In Progress" + (log.createdByName ? ` by ${log.createdByName}` : '') + ')'}</div>
        break;
      case 'compensationIssued':
        msg = <div>{createdBy + ` issued a ${String(log.description || 'Compensation').toLowerCase()} of ${aed(log.amount)}`}
          {log.exp ? ` (expires ${moment(log.exp).format('DD/MM/YYYY')})` : ''}</div>
        break;
      case 'recoveryMarkedPaid':
        msg = <div>{createdBy + ` completed the towing order as already ${log.method === 'cash' ? 'paid in cash' : 'paid by payment link'}: ${aed(log.amount)} (card not charged)`}
          {log.reference ? <><br />{'Reference: ' + log.reference}</> : null}
          {log.note ? <><br />{'Note: ' + log.note}</> : null}</div>
        break;
      case 'canceledOrderChargeConfirmed':
        msg = createdBy + ' confirmed charging the card on a cancelled towing order (customer had not paid any other way)'
        break;
      case 'priceRepaired':
        msg = `${createdBy.trim() || 'System'} corrected the order price (app VAT bug): ${log.oldTotal === 0 || log.oldTotal ? aed(log.oldTotal) : '—'} → ${aed(log.newTotal)}`
        break;
      case 'priceRepairNeedsReview':
        msg = 'Order price looks wrong (app VAT bug) and a discount was used — needs a manual check'
        break;
      default:
        // Never a blank line: an entry type this panel doesn't describe yet still shows what it is.
        msg = `${createdBy.trim() ? createdBy.trim() + ' — ' : ''}${log.title || 'Update'}`
        break;
    }
    return msg
}

// The list itself, usable inline (Rated Orders case modal) or inside the Logs modal.
// `newestFirst` reverses the stored order; `maxHeight` turns it into a scroll box.
export const LogsTable = ({ logs, selectedBooking, newestFirst = false, maxHeight, emptyText = 'No data to show' }) => {
  const entries = Array.isArray(logs?.data) ? (newestFirst ? [...logs.data].reverse() : logs.data) : [];
  if (!entries.length) {
    return (
      <div style={{ width: '100%', fontSize: maxHeight ? '14px' : '18px', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: '600', color: maxHeight ? '#8f8f8f' : undefined, padding: maxHeight ? '12px 0' : 0 }}>{emptyText}</div>
    );
  }
  const table = (
    <table className="table table-sm table-borderless mb-0">
      <tbody>
        {entries.map((log, index) => (
          <tr key={index}>
            <td style={{ width: '18px' }}>
              <span style={{ borderColor: colors[log.title] }} className={`log-indicator align-middle ${log.color}`} />
            </td>
            <td>
              <span className="font-weight-medium">{generateLogMessage(log, selectedBooking)}</span>
            </td>
            <td className="text-right" style={{ width: '29%' }}>
              <span className="text-muted">{moment(log.created).format("DD/MM/YYYY hh:mm A")}</span>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
  if (maxHeight) return <div style={{ maxHeight, overflowY: 'auto' }}>{table}</div>;
  return <PerfectScrollbar option={{ suppressScrollX: true, wheelPropagation: false }}>{table}</PerfectScrollbar>;
};

class Logs extends Component {
  render() {
    let { dismiss, logsOpen, logs, selectedBooking } = this.props
    return (
      <Modal
        isOpen={logsOpen}
        style={{ boxShadow: 'none', maxWidth: '600px', top: '30px', overflow: 'hidden', borderRadius: '14px' }}
        toggle={dismiss}
        backdrop="static"
        size="lg">
        <ModalHeader toggle={dismiss}>Logs</ModalHeader>
        <ModalBody >
          <div className="dashboard-logs">
            <LogsTable logs={logs} selectedBooking={selectedBooking} />
          </div>
        </ModalBody >
      </Modal >);
  }

};
export default Logs;
